export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

export async function postJson<TResp>(url: string, body: unknown): Promise<TResp> {
  const r = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  });
  if (!r.ok) throw await asApiError(r);
  return (await r.json()) as TResp;
}

export async function getJson<TResp>(url: string): Promise<TResp> {
  const r = await fetch(url, { credentials: 'same-origin' });
  if (!r.ok) throw await asApiError(r);
  return (await r.json()) as TResp;
}

async function asApiError(r: Response): Promise<ApiError> {
  let code = 'http_error';
  let message = `HTTP ${r.status}`;
  try {
    const body = (await r.json()) as { code?: string; error?: string };
    if (body.code) code = body.code;
    if (body.error) message = body.error;
  } catch { /* ignore */ }
  return new ApiError(r.status, code, message);
}
